function getRandomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export default function getCaptcha() {
  const first = getRandomNumber(1, 10);
  const second = getRandomNumber(1, 10);
  const third = getRandomNumber(1, 10);

  const result = first + second * third;
  const text = `${first} + ${second} * ${third} = `
  return {
    result,
    text
  }
};